
<template>
  <div >
    <v-container  fluid  v-bind="{ [`grid-list-${dev_view}`]: true }" mt-2>
        
        <!-- <test></test> -->
        <!-- <v-divider></v-divider> -->
        <!-- {{active_tab}} -->
        <v-layout row nowrap >
        
        <v-flex :class="classObject" sm6 xs6 py-0 mb-2>
          <div class="bg-info  mb-0 border-0 app-card">
            <v-card-text>
              <div class="layout justify-space-between pa-0 ">
                <div class="align-item-start">
                    <div class='total_info'>
                        <span class='total_num'>{{sum_info.total_num - sum_info.total_save_num }}</span>
                        <span v-if="sum_info.total_save_num" >
                           存
                          <span class='total_save' style="font-size: 32px;color:red">
                            {{sum_info.total_save_num}}
                          </span> 
                        </span>
                    </div>
                </div>

                <div class="align-item-start">
                  <h3 class="total_money" @click.stop="make_to_int()">￥{{bill_money}} </h3>
                  <p class="ma-0 fs-14">
                      <del v-if="sum_info.total_less+ sum_info.less_to_int>0">
                            优惠￥{{(sum_info.total_less+ sum_info.less_to_int ).toFixed(2)}}
                      </del>
                      <span v-if="sum_info.use_prepay>0"class="red--text title">会员卡:{{sum_info.use_prepay.toFixed(2)}}</span>
                      <del v-if="sum_info.amount_less >0">积分￥{{sum_info.amount_less.toFixed(2)}}</del>
                      <del v-if="sum_info.less_to_int >0">抹零￥{{sum_info.less_to_int.toFixed(2)}}</del>
                  </p>
                </div>


              </div>
            </v-card-text>
          </div>
        </v-flex>
        <v-flex :class="classObject" sm6 xs6 py-0 mb-2 v-if="vip_info.mobile">
          <div class="bg-secondary mb-0 border-0 app-card">
            <v-card-text>
              <div class="layout justify-space-between pa-0">
                <div class="align-item-start">

                    <v-menu offset-y>
                      <v-avatar slot="activator" class="drop-menu"
                        :tile="title"
                        color="grey lighten-4"
                      >
                          <img src="/static/img/user-7.jpg" alt="avatar">
                      </v-avatar>
                      <v-list>
                        <v-list-tile @click="lookup_vip_info(vip_info.mobile)">
                          <v-icon class="mr-3 font-lg text-gray">ti-reload</v-icon>
                          <v-list-tile-title>刷新会员</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                      <v-list>
                        <v-list-tile @click="clear_vip()">
                          <v-icon class="mr-3 font-lg text-gray">ti-close</v-icon>
                          <v-list-tile-title>清除会员</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                      <v-list>
                        <v-list-tile @click='add_vip("edit")'>
                          <v-icon class="mr-3 font-lg text-gray">ti-pencil</v-icon>
                          <v-list-tile-title>修改会员</v-list-tile-title>
                        </v-list-tile>
                      </v-list>

                      <v-list>
                        <v-list-tile @click='show_dialog("SHOW_DIALOG_VIP_RECHARGE")'>
                          <v-icon class="mr-3 font-lg text-gray large">ti-money</v-icon>
                          <v-list-tile-title>会员充值</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                      

                      <v-list v-if="vip_saved&&vip_saved.length">
                        <v-list-tile @click="lookup_vip_saved()">
                          <v-icon class="mr-3 font-lg text-gray">ti-save</v-icon>
                          <v-list-tile-title>暂存商品</v-list-tile-title>
                        </v-list-tile>
                      </v-list>

                      <v-list>
                        <v-list-tile to="/users/user-profile">
                          <v-icon class="mr-3 font-lg text-gray">ti-list</v-icon>
                          <v-list-tile-title>购买记录</v-list-tile-title>
                        </v-list-tile>
                      </v-list>

                    </v-menu>
                  
                </div>
                
                <div class="align-item-start">
                  <h3 class="prepay_money" @click="use_prepay_money()">￥{{vip_info.prepay_money?vip_info.prepay_money.toFixed(2):0}}</h3>
                  <p class="ma-0 fs-14" @click="use_amount()" >积分:{{vip_info.user_amount?vip_info.user_amount:0}}</p>
                </div>



                <div class="align-item-start">
                  <h3 class="" style="margin:0 0;" >{{vip_info.name}} </h3>
                  <p class="ma-0 fs-14">{{vip_info.mobile}}</p>
                </div>

                <div class="align-item-end" v-if="vip_saved&&vip_saved.length">
                    <v-btn icon @click="lookup_vip_saved()" class="d-inline-50">
                      <v-icon  color="orange darken-2" style="font-size: 250%">ti-save</v-icon>
                    </v-btn>
                </div>
              </div>
            </v-card-text>
          </div>
        </v-flex>
        <!-- offset-xl6 offset-lg6 offset-md6 offset-sm6 -->
        <v-flex :class="classObject" sm12 xs12 py-0 mb-2  >
            <div class="input_pad  mb-0 border-0 app-card">
              <v-card-text>
                <div class="layout justify-space-between pa-0 "> 
                 <!-- <v-text-field 
                  label="条码 会员号"
                  solo-inverted
                  class="mx-3 gid_control"
                  single-line
                  clearable
                  autofocus
                  flat
                  hint="hint"
                  @input="gid_input"
                  @keyup.13="lookup_product(true)"
                  v-model='input_gid'
                ></v-text-field> -->
                <input class="gid_control" 
                  @input="gid_input"
                  @keyup.13.stop="lookup_product(true)"
                  v-model='input_gid'
                  type="search" 
                  placeholder="条码/会员号" 
                  autocomplete="off" 
                  autocorrect="off" 
                  autocapitalize="off" 
                  spellcheck="false" />
                <v-btn v-if="input_gid.length" icon @click="clear_input(true)" class="d-inline-50">
                  <span class="black--text" style="font-size: 250%">x</span>
                </v-btn>
                <v-btn v-else icon @click="do_pay_money" class="d-inline-50">
                  <span class="pink--text" style="font-size: 250%">￥</span>
                </v-btn>
              </div>
              </v-card-text>
            </div>

          
        </v-flex>
      </v-layout>

        <v-flex xl12 lg12 md12 xs12>
          <div >
            <v-alert :value="pay_info.pay_status"  type="success" transition="scale-transition">
                <h2 >
                    <span class="pink--text">本单已经结算！</span>
                    <span>{{pay_info_str}}</span>
                </h2>
            </v-alert>
          </div>

          <v-tabs
            slot="extension"
            v-model="active_tab"
            right
            slider-color="yellow"
          > 
            <v-btn v-if="pay_info.pay_status" icon  class="d-inline-50">
              <v-icon large color="purple darken-2">ti-print</v-icon>
            </v-btn>
            <div v-else>
                  <!-- <v-btn icon @click="edit_sale_note_dlg('订单备注')" class="d-inline-50">
                    <v-icon large color="green darken-2">edit</v-icon>
                  </v-btn> -->

                  <v-menu offset-y>
                    <v-btn slot="activator"color="info" dark > 更多操作 </v-btn>
                    <v-list>
                      <v-list-tile @click="show_ship_out_dialog('ship_out')">
                        <v-icon class="mr-3 font-lg text-gray">ti-sharethis</v-icon>
                        <v-list-tile-title>出库</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="show_ship_out_dialog('recv')">
                        <v-icon class="mr-3 font-lg text-gray">ti-shopping-cart</v-icon>
                        <v-list-tile-title>收货</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="show_destroy_dialog('destroy')">
                        <v-icon class="mr-3 font-lg text-gray">ti-trash</v-icon>
                        <v-list-tile-title>报损</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="show_ship_out_dialog('request')">
                        <v-icon class="mr-3 font-lg text-gray">ti-receipt</v-icon>
                        <v-list-tile-title>配货申请</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="show_ship_out_dialog('pandian')">
                        <v-icon class="mr-3 font-lg text-gray">ti-list</v-icon>
                        <v-list-tile-title>盘点</v-list-tile-title>
                      </v-list-tile>
                      
                    </v-list>
                  </v-menu>

                  <v-menu offset-y v-if="selected_num">
                    <v-btn
                    slot="activator"
                    icon>
                    <v-icon class='iconfont icon-more'></v-icon>
                  </v-btn>
                    <v-list>
                     <v-layout row justify-space-around>
                        <v-flex xs3><v-btn depressed small color="light-green lighten-3" @click="set_discount(90)">90折</v-btn></v-flex>
                        <v-flex xs3><v-btn depressed small color="light-blue lighten-3" @click="set_discount(88)">88折</v-btn></v-flex>
                        <v-flex xs3><v-btn depressed small color="warning" @click="set_discount(85)">85折</v-btn></v-flex>
                        <v-flex xs3><v-btn depressed small color="success" @click="set_discount(80)">80折</v-btn></v-flex>
                      </v-layout>
                      <v-layout row justify-space-around>
                        <v-flex xs3><v-btn depressed small color="success" @click="set_discount(75)">75折</v-btn></v-flex>
                        <v-flex xs3><v-btn depressed small color="warning" @click="set_discount(70)">70折</v-btn></v-flex>
                        <v-flex xs3><v-btn depressed small color="light-blue lighten-3" @click="set_discount(61)">61折</v-btn></v-flex>
                        <v-flex xs3><v-btn depressed small color="light-green lighten-3" @click="set_discount(50)">50折</v-btn></v-flex>
                      </v-layout>
                      <v-layout row justify-space-around>
                        <v-flex xs6><v-btn depressed small color="success" @click="set_discount(100)">不打折</v-btn></v-flex>
                        <v-flex xs6><v-btn depressed small color="light-blue" @click="def_discount()">自定义</v-btn></v-flex>
                      </v-layout>
                    </v-list>
                  </v-menu>

            </div>


            <v-spacer></v-spacer>
            <v-tab href="#tab-sale">待售表</v-tab>
            <v-tab href="#tab-prepare">预选表</v-tab>
            <v-tab href="#tab-shortcut">速记表</v-tab>
          </v-tabs>
    
          <v-tabs-items v-model="active_tab">
            
            <sale-tab name="tab-sale" ></sale-tab>
            <prepare-tab name="tab-prepare" 
              @active_tab="act_tab" 
              @clear_input="clear_input(true)"></prepare-tab>
            <shortcut-tab name="tab-shortcut"></shortcut-tab>

            </v-tab-item>


          </v-tabs-items>
        </v-flex>

      <!-- <dialog_take_money></dialog_take_money> -->
      <!-- <dialog_user_input></dialog_user_input> -->
      <!-- <dialog_pay_order ></dialog_pay_order> -->
      <dialog_user_pay></dialog_user_pay>
      <!-- <dialog_vip_edit></dialog_vip_edit> -->
      <dialog_ship_out></dialog_ship_out>
      <dialog_destroy></dialog_destroy>
      <dialog_vip_recharge @recharge="recharge" :config="recharge_conf"></dialog_vip_recharge>

      <!-- <div @click = "show_dialog">SHOW</div> -->
      <!-- <test></test> -->
    </v-container>
  </div>
</template>

<script>
  /* eslint-disable */
import { mapGetters ,mapMutations} from 'vuex'
import SaleTab from "./components/saleorder";
import PrepareTab from "./components/prepare";
import ShortcutTab from "./components/shortcut";
// import dialog_take_money from  "./dialogs/dialog_take_money";
import dialog_user_pay  from "./dialogs/dialog_user_pay";
// import dialog_user_input from "./dialogs/dialog_user_input";
// import dialog_pay_order from "./dialogs/dialog_pay_order";
// import dialog_vip_edit from "./dialogs/dialog_vip_edit";
import dialog_ship_out from "./dialogs/dialog_ship_out";
import dialog_destroy from "./dialogs/dialog_destroy";
import dialog_vip_recharge from "./dialogs/dialog_vip_recharge";
import Test from "./components/test";
import device_api from "../../api/local_device"
// import countTo from "vue-count-to";
// import {lookup_vip}from "@/api/module/vip"
import debounce from 'debounce';
import prompt_dlg from './mixin/mix_prompt_dlg'
import mix_sale from './mixin/mix_sale'
import mix_cmds from './mixin/mix_commands'
import g_mix from '@/mixin/g_sale'

export default {
  components: {
    SaleTab,
    PrepareTab,
    ShortcutTab,
    // countTo,
    Test,
    // dialog_user_input,
    // dialog_take_money,
    // dialog_pay_order,
    dialog_user_pay,
    // dialog_vip_edit,
    dialog_ship_out,
    dialog_destroy,
    dialog_vip_recharge
  },
  mounted(){
      this.active_tab='tab-sale';
  },
  mixins:[prompt_dlg,mix_sale,mix_cmds,g_mix],
  computed: {
    dev_view: function () { 
      return this.$vuetify.breakpoint.name;
    },
    
    classObject: function () {
      if(this.vip_info.mobile) return {xl4:true,lg4:true,md4:true}
      return {xl6:true,lg6:true,md6:true}
    },
    ...mapGetters({
      mutil_index   :'get_mutil_index',

      vip_info      :'vip_info',
      vip_saved     :'vip_saved',

      sum_info      :'get_products_sum_info',
      pay_info      :'get_pay_info',
      order_id      :'get_order_id',
      order_note    :'get_order_note',

      prodcuts_list :'get_prodcuts_list',
      selected_num  :'get_selected_num',
      
      post_data    :'get_sale_post_data',
      prepay_money :'get_use_prepay_money',
      amount_less  :'get_amount_less',
      shop_info    :'shop_info'

    }),
    active_tab:{
      get(){
          return this.$store.state.dialog.show_active_tab_dialog;
      },
      set(val){
          // if(val == 'tab-prepare') debugger
          this.$store.commit('SHOW_DIALOG_ACTIVE_TAB',val)
      }
    },
    pay_info_str:function(){
        let pay_info = this.pay_info;
        if(pay_info.title) return pay_info.title;
        let type     = pay_info.pay_type;
        let prepay   = "";
        let cash     = "";
        let string = "";
        if(pay_info.pay_status <=0) string = '';

        if(pay_info.use_prepay){
            prepay = `会员卡支付:${this.sum_info.use_prepay}元`;
        }
        if(pay_info.recv){
            cash = `现金支付:${this.pay_info.recv}`
        }
        if(type == 'cash'){
            if(pay_info.bank_id){
                string = `银行卡支付:${pay_info.total_money - pay_info.recv} ` + `${cash}` + prepay;
            }else{
                string = `${cash}`;
                if(this.pay_info.recv>0){
                    string += ` 找零: ${pay_info.ret.toFixed(2)}`;
                }
                string += prepay
            }
        }
        else if(type == "weixin"){
            string = `微信支付  ` + prepay + cash;
        }
        else if(type == "alipay"){
            string = `支付宝支付 ` + prepay + cash;
        }
        else if(type == "mall"){
            string = `商场代收 `  + prepay + cash;
        }
        else if(type == "bank"){
            string = `银行卡支付 ` + prepay + cash;
        }
        console.log("Pay String:",string)
        return string
    }
  },
  methods: {
    ...mapMutations({
        edit_item       :'PRODUCTS_EDIT_ITEM',
        inc_mul_index   :'PRODUCTS_LIST_INC_MUL_INDEX',
        set_discount    :'PRODUCTS_DISCOUNT_SELECTED',
        act_tab         :'SHOW_DIALOG_ACTIVE_TAB',
    }),
    log(str) {
       console.log(str);
    },
    
    add_vip(type){
        this.show_dialog('SHOW_DIALOG_EDITVIP',type)
    },
    clear_input(is_sale){
        this.input_gid ='';
        if(is_sale) this.act_tab('tab-sale');
    },
    gid_input: debounce(function(e){
            let gid = this.input_gid
            if(gid && gid.length >2){
                this.lookup_product();
            }else if(!gid){
              this.act_tab('tab-sale')
            }
        },350),
    do_pay_money(){
        let self = this;
        debugger
        let ready = self.ready_for_sale() ;
        if(!ready) return;

        function do_it(pay_info){
            debugger
            let post_data = self.sale_detail(pay_info);
            return self.do_post_sale(post_data).then(doc=>{
                if(doc){
                  self.show_dialog('SHOW_DIALOG_USER_PAY',false);
                  debugger
                  doc.shop = self.shop_info;
                  self.confirm_dlg("是否打印小票？").then(_=>{
                  device_api.post_printer(doc);
                  }).catch(err=>{

                  })
                }
            })
        }

        if(self.sum_info.total_money >0 && self.sum_info.total_money == self.prepay_money){
            self.confirm_dlg("使用充值卡结算？").then(_=>{
                let p_pay = {
                        pay_type   : "cash",
                        recv_money : 0,
                        where      : "store",
                        taobao     : false,
                        bank_id    : "",
                        auth_code  : "",
                    }
                do_it(p_pay)
            }).catch()
            return;
        }

        self.show_dialog('SHOW_DIALOG_USER_PAY',{
            money        : self.sum_info.total_money - self.sum_info.use_prepay,
            prepay_money : self.prepay_money,
            callback     : async(pay_info)=>{await do_it(pay_info)}
        })
    },
    show_destroy_dialog(){

        this.ready_for_sale('destory')&& this.show_dialog('SHOW_DIALOG_DESTROY',true)
    },
    show_ship_out_dialog(type="ship_out"){
        this.ready_for_sale(type) && this.show_dialog('SHOW_DIALOG_SHIP_OUT',type);
    },
    def_discount(){
        var self = this;
        self.prompt_dlg("请输入自定义折扣","自定义折扣",'discount',(val,dlg)=>{
          if(/^[0-9]*$/.test(val)){
              val *=1;
              if(val >=0&&val <=100){
                  return val;
              }
          }
          return false
        }).then(disc=>{
            self.set_discount(disc);
        }).catch(e=>{

        })
    },
    lookup_vip_saved(){
        var self = this;
        let saved = self.vip_saved;
        if(saved.length ==0){
          return self.msgpad_show("msgpad", "ERROR", '会员信息错误', 'error');
        }
        self.$store.commit('PRODUCTS_PREPARE_LIST',saved);
        self.active_tab = 'tab-prepare';
    },
    recharge(val){
       var self = this;
       debugger
       // this.$set(this,'recharge_conf',val)
       console.log("RECHARGE:",val)
       if(!val.mobile){
            return self.msgpad_show("msgpad", "ERROR", '会员信息错误', 'error');
       }
       if(val.money+ val.ext == 0){
            self.show_dialog('SHOW_DIALOG_USER_PAY',false);
            return self.msgpad_show("msgpad", "ERROR", '充值金额为0', 'error');
       }
       val.callback = (pay_info)=>{
            if(!pay_info){
              debugger
              return;
            }
            let post_data = self.vip_prepay_fake_order(`${self.order_id}-${self.mutil_index}`,val.mobile,pay_info,val.note)
            // debugger;
            console.log("recharge - pay_info:", pay_info)
            console.log("recharge - post_data:", post_data)

            self.do_post_sale(post_data).then(doc=>{
                if(doc){
                    console.log("SALE OK:",doc);
                    self.msgpad_show("msgpad", "成功", '充值金额成功', 'success');
                    self.show_dialog('SHOW_DIALOG_USER_PAY',false);
                    self.show_dialog('SHOW_DIALOG_VIP_RECHARGE',false);
                    self.$store.commit('PRODUCTS_LIST_INC_MUL_INDEX');
                    self.lookup_vip_info(val.mobile,()=>{
                        debugger
                        self.msgpad_show("msgpad", "成功", '会员信息更新成功', 'success');
                    });
                }
            }).catch(err=>{
                return self.msgpad_show("msgpad", "ERROR", '充值失败,请稍后再试。', 'error');
            })
       }
       this.show_dialog('SHOW_DIALOG_USER_PAY',val);
    }
  },
  data() {
    return {
       // recharge :0,
       recharge_conf:{},
       avatar_size:'large',
       title:false,
       size:32,
       input_gid:'',
       form1:{
         money:null,
         who:"",
         bywho:"",
       }

    }
  }      
};

</script>
<style scoped>
  
  .total_info > .total_num{
      font-size: 62px !important;
      line-height: 42px;
  }

  .total_info > .total_save{
      font-size: 32px !important;
      line-height: 32px;
      color: red;
  }
  .total_money {
      font-size: 32px !important;
      line-height: 30px;
      font-weight: bold;
      margin:0 0;
  }
  .prepay_money{
    font-size: 22px !important;
      line-height: 30px;
      font-weight: bold;
      margin:0 0;
  }
  .menu__content .list{
    margin :0px;
  }
  .input_pad{
    background: #ebccd1;
  }
  input[name="auto_gid"]{
      height      : 60px;
      font-size   : 32px !important;
      line-height : 30px;
  }
  .input-group.input-group--solo {
    min-width: 90% !important;;
    width : 100% !important;
    margin: 0 0 !important;
  }
  .gid_control {
    height: 100% !important;;
    width : 100% !important;;
    font-size: 35px !important;;
    color:#a94442;

    background-attachment :scroll, scroll;
    background-blend-mode :normal, normal;
    background-clip       :padding-box, padding-box;
    background-color      :rgba(0, 0, 0, 0);
    background-image      :linear-gradient(rgb(3, 169, 244), rgb(3, 169, 244)), linear-gradient(rgb(210, 210, 210), rgb(210, 210, 210));
    background-origin     :padding-box, padding-box;
    background-position   :50% 100%, 50% calc(-1px + 100%);
    background-repeat     :no-repeat, no-repeat;
    background-size       :0px 2px, 100% 1px;

    border-bottom-color:rgb(73, 80, 87);
    border-bottom-left-radius:0px;
    border-bottom-right-radius:0px;
    border-bottom-style:none;
    border-bottom-width:2px;
    
    outline-color         :rgb(73, 80, 87);
    outline-offset        :0px;
    outline-style         :none;
    outline-width         :0px;
}
</style>



// WEBPACK FOOTER //
// src/views/front_sale/sale.vue